export enum TypeLocalityLevelEnum {
  Ibge = -1,
  Client = 2
}
